import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import imgXs from '../../images/pond/pennies-440.jpg';
import imgSm from '../../images/pond/pennies-660.jpg';
import imgMd from '../../images/pond/pennies-900.jpg';
import imgLg from '../../images/pond/pennies-1200.jpg';
import imgXl from '../../images/pond/pennies-1600.jpg';
import imgXxl from '../../images/pond/pennies-1900.jpg';
import ErrorBoundary from '../../ErrorBoundary';

const Wrapper = styled.div`
  padding-top: 5vw;
  padding-bottom: 5vw;
  @media (min-width: 660px) {
    padding-top: 10vw;
    padding-bottom: 10vw;
  }
`;
function PondWrap({ className = '', ...props }) {
  const classNames = [
    'pond-pond-wrap uk-position-relative uk-flex uk-flex-column uk-flex-center uk-background-fixed uk-background-top-center uk-background-repeat',
    className,
  ].join(' ');

  const dataSrcSet = [
    `
      ${imgXs} 440w,
      ${imgSm} 660w,
      ${imgMd} 900w,
      ${imgLg} 1200w,
      ${imgXl} 1600w,
      ${imgXxl} 1900w
    `,
  ];

  const dataSizes = [
    `
    (max-width: 440px) 440px,
    (max-width: 660px) 660px,
    (max-width: 900px) 900px,
    (max-width: 1200px) 1200px,
    (max-width: 1600px) 1600px,
    1900px
  `,
  ];

  const dataUkImg = `target: !.lazyload-pennies`;
  const dataHeight = `100%`;
  const dataWidth = `100%`;

  return (
    <ErrorBoundary>
      <Wrapper
        className={classNames}
        data-srcset={dataSrcSet}
        data-sizes={dataSizes}
        data-src={imgXxl}
        data-uk-img={dataUkImg}
        data-height={dataHeight}
        data-width={dataWidth}
      >
        {props.children}
      </Wrapper>
    </ErrorBoundary>
  );
}

PondWrap.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

export default PondWrap;



// WEBPACK FOOTER //
// ./src/features/pond/PondWrap.js